import di from "../../../../dependency_injection";
import MasterItemEntity from "../../../../domain/entities/master_item.entity";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const getCallTypesApiImpl = async (): Promise<MasterItemEntity[]> => {
    try {
        const relativeUrl: string = "/call-types";
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.map((item: any) => {
            return {
                id: item.name,
                name: item.name,
            }
        });
        return parsed;
    } catch (e) {
        return [];
    }

}

export default getCallTypesApiImpl;